import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractSearchInput} from "../abstract-search-input";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIPopSearchInputComponent),
            multi: true
        }
    ],
    selector: "fui-pop-search-input",
    styleUrls: ["./pop-search-input.component.scss"],
    templateUrl: "./pop-search-input.component.html",
    standalone: false
})
export class FUIPopSearchInputComponent extends FUIAbstractSearchInput {
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, changeDetectorRef);
    }
}
